import { Controller } from "@hotwired/stimulus"
import confetti from "canvas-confetti"

import { hasCelebrated, parseCelebratedKeys, recordCelebration } from "./celebrate_helpers.mjs"

// Fires one short burst of confetti for a milestone the Creator just reached:
// a directory listing confirmed live, or an Episode that finished publishing.
//
// The palette is the creator dashboard's own ink, green, orange and violet, so
// the burst reads as part of the product rather than a generic celebration.
const PALETTE = ["#1f2f66", "#22c55e", "#f97316", "#8a92ad", "#f4edff"]

const SEEN_STORAGE_KEY = "veronese:celebrated"

export default class extends Controller {
  static values = {
    key: String
  }

  connect() {
    if (this.prefersReducedMotion) return
    if (this.alreadyCelebrated) return

    this.markCelebrated()
    this.burst()
  }

  get prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches
  }

  get seenKeys() {
    try {
      return parseCelebratedKeys(window.sessionStorage.getItem(SEEN_STORAGE_KEY))
    } catch (_error) {
      return []
    }
  }

  get alreadyCelebrated() {
    return hasCelebrated(this.seenKeys, this.keyValue)
  }

  markCelebrated() {
    try {
      const keys = recordCelebration(this.seenKeys, this.keyValue)
      window.sessionStorage.setItem(SEEN_STORAGE_KEY, JSON.stringify(keys))
    } catch (_error) {
      // Private browsing can refuse storage. Celebrating twice is harmless.
    }
  }

  burst() {
    const shared = {
      colors: PALETTE,
      disableForReducedMotion: true,
      scalar: 0.9,
      ticks: 180,
      zIndex: 2000
    }

    // Two low bursts angled in from the page edges read as a ribbon across the
    // work area, rather than a single blast over the middle of the content.
    confetti({ ...shared, particleCount: 55, spread: 60, angle: 60, origin: { x: 0, y: 0.75 } })
    confetti({ ...shared, particleCount: 55, spread: 60, angle: 120, origin: { x: 1, y: 0.75 } })

    window.setTimeout(() => {
      confetti({ ...shared, particleCount: 40, spread: 90, startVelocity: 32, origin: { x: 0.5, y: 0.6 } })
    }, 160)
  }
}
